import classnames from "classnames";
import React, { ReactNode } from "react";
import { findDataAttrProps } from "../../../utils/props";
import styles from "./Col.module.scss";

type Props = {
  children: ReactNode;
  className?: string;
  as?: React.ElementType;
  lg?: number | "auto";
  md?: number | "auto";
  offsetXs?: number;
  offsetSm?: number;
  offsetMd?: number;
  sm?: number | "auto";
  xs?: number | "auto";
};

const Col = (props: Props) => {
  const {
    children,
    className,
    as: Component = "div",
    md,
    offsetXs,
    offsetSm,
    offsetMd,
    sm,
    lg,
    xs = "auto"
  } = props;

  const cssStyles = classnames(
    className,
    offsetXs && `col-xs-offset-${offsetXs}`,
    offsetSm && `col-sm-offset-${offsetSm}`,
    typeof offsetSm === "number" && offsetSm === 0 && styles.colSmOffset0,
    offsetMd && `col-md-offset-${offsetMd}`,
    typeof offsetMd === "number" && offsetMd === 0 && styles.colMdOffset0,
    xs && `col-xs-${xs}`,
    xs && xs === "auto" && `col-xs`,
    sm && `col-sm-${sm}`,
    sm && sm === "auto" && `col-sm`,
    md && `col-md-${md}`,
    md && md === "auto" && `col-md`,
    lg && `col-lg-${lg}`,
    lg && lg === "auto" && `col-lg`
  );

  return (
    <Component {...findDataAttrProps(props)} className={cssStyles}>
      {children}
    </Component>
  );
};

export default Col;
